import styled from 'styled-components';

import { useGlobalStore } from '../../state/globalStore';

export const ProgressBar = ({ value = 50 }) => {
  const {
    leadCapture: {
      primaryButtonStyle: { buttonColor },
    },
  } = useGlobalStore((store) => store);
  return (
    <Wrapper>
      <Progress progressColor={buttonColor || '#00adef'} percent={value} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  pointer-events: none;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  background: linear-gradient(to right, rgb(144, 137, 148), rgb(173, 180, 190));
`;

const Progress = styled.div<{ percent: number; progressColor: string }>`
  pointer-events: none;
  height: 6px;
  background: ${({ progressColor }) => progressColor};
  border-radius: 3px;
  width: ${({ percent }) => percent}%;
`;
